import { __assign, __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import Plus from 'wix-ui-icons-common/Add';
import ListItem from '../common/ListItem';
import { Popover, Search, DropdownLayout, TextButton, Divider, Box, Checkbox, } from 'wix-style-react';
var newLabel = { id: '', name: '' };
var SelectLabels = /** @class */ (function (_super) {
    __extends(SelectLabels, _super);
    function SelectLabels(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
            searchText: '',
            showCreateLabelButton: true,
        };
        return _this;
    }
    SelectLabels.prototype.onSearchTextChanged = function (text) {
        var onSearch = this.props.onSearch;
        this.setState({ searchText: text });
        onSearch(text);
    };
    SelectLabels.prototype.handleNewButtonClick = function () {
        this.props.onCreateClick();
        this.setState({ showCreateLabelButton: false });
    };
    SelectLabels.prototype.handleNewLabelXClick = function () {
        this.setState({ showCreateLabelButton: true });
    };
    SelectLabels.prototype.handleNewLabelVClick = function (newName) {
        this.setState({ showCreateLabelButton: true });
        this.props.onCreate(newName);
    };
    SelectLabels.prototype.handlePopoverClick = function () {
        var isShownNew = !this.state.isShown;
        this.setState({ isShown: isShownNew });
        if (!isShownNew) {
            this.props.onClose();
        }
    };
    SelectLabels.prototype.handlePopoverClickOutside = function () {
        this.setState({ isShown: false });
        this.props.onClose();
    };
    SelectLabels.prototype.getLabelsOptions = function () {
        var _a = this.props, labels = _a.labels, onLabelClicked = _a.onLabelClicked;
        return labels.map(function (label, index) { return ({
            id: label.id,
            value: (React.createElement(Checkbox, { dataHook: "select-label-" + index, checked: label.isChecked, indeterminate: label.isIndeterminate, onChange: function () { return onLabelClicked(label.id); } }, label.name)),
        }); });
    };
    SelectLabels.prototype.renderHeader = function () {
        var _this = this;
        var _a = this.props, t = _a.t, flip = _a.flip;
        return (React.createElement("div", { style: {
                padding: flip ? '22px 22px 10px 22px' : '24px 24px 10px 24px',
            } },
            React.createElement(Search, { dataHook: "labels-list-search", placeholder: t('searchLabelsPlaceholder'), onChange: function (e) { return _this.onSearchTextChanged(e.target.value); }, onClear: function () { return _this.onSearchTextChanged(''); }, value: this.state.searchText })));
    };
    SelectLabels.prototype.renderFooter = function () {
        var _this = this;
        var _a = this.props, t = _a.t, onManageLabelsClick = _a.onManageLabelsClick, validateUniqueName = _a.validateUniqueName, flip = _a.flip;
        return (React.createElement(Box, { direction: "vertical", paddingLeft: !flip && '2px' },
            React.createElement(Box, { paddingLeft: "22px", paddingTop: "10px" }, this.state.showCreateLabelButton ? (React.createElement(TextButton, { onClick: function () { return _this.handleNewButtonClick(); }, dataHook: "create-label", prefixIcon: React.createElement(Plus, null) }, t('createLabel'))) : (React.createElement(ListItem, { dataHook: "new-label-item", name: newLabel.name, mode: "edit", onCancelEdit: function () { return _this.handleNewLabelXClick(); }, validateUniqueItem: validateUniqueName, onUpdate: function (newName) { return _this.handleNewLabelVClick(newName); }, hideEditBG: true, deleteTooltipText: t('itemDeleteButtonTooltip'), renameTooltipText: t('itemRenameButtonTooltip'), alreadyExistsText: function (name) { return t('labelExists', { name: name }); } }))),
            React.createElement(Box, { padding: "10px 8px" },
                React.createElement(Divider, null)),
            React.createElement(Box, { paddingLeft: "22px", paddingBottom: flip ? '18px' : '20px', paddingTop: "5px" },
                React.createElement(TextButton, { dataHook: "manage-labels", onClick: function () { return onManageLabelsClick(); } }, t('manageLabels')))));
    };
    SelectLabels.prototype.render = function () {
        var _this = this;
        var _a = this.props, target = _a.target, popoverPlacement = _a.popoverPlacement, flip = _a.flip;
        var containerProps = flip
            ? {
                backgroundColor: 'FFFFFF',
                padding: '2px',
                borderRadius: '8px',
            }
            : {};
        return (React.createElement(Popover, { dataHook: "labels-list-popover", onClick: function () { return _this.handlePopoverClick(); }, onClickOutside: function () { return _this.handlePopoverClickOutside(); }, showArrow: true, appendTo: "viewport", placement: popoverPlacement || 'bottom-end', shown: this.state.isShown, width: "340px" },
            React.createElement(Popover.Element, null, target),
            React.createElement(Popover.Content, null,
                React.createElement(Box, __assign({}, containerProps),
                    React.createElement(DropdownLayout, { visible: true, dataHook: "labels-list", options: this.getLabelsOptions(), maxHeightPixels: "400px", selectedHighlight: false, fixedHeader: this.renderHeader(), fixedFooter: this.renderFooter(), inContainer: flip })))));
    };
    return SelectLabels;
}(React.PureComponent));
export default translate()(SelectLabels);
//# sourceMappingURL=SelectLabels.js.map